import { createContext, useContext } from 'react'
import type { VideoContext } from '../stores/videoPlaybackStore'

export const SurfaceVideoContextRef = createContext<VideoContext>('feed')

export function useSurfaceVideoContext(): VideoContext {
  return useContext(SurfaceVideoContextRef)
}
